import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { formatDateToYYYYMMDD } from '@/utils';
import { ROUTE_DEFINITIONS } from '@/routes';


export interface UseTodayMarksDetailNavigationResult {
  handleViewTodayMarksDetail: () => void;
}

// Data hook for the "Mi asistencia" dashboard "Marcajes de hoy" card "Ver detalle"
// action (ASIS-5393 / REXASIS-002). Redirects to "Mis registros de asistencia" scoped
// to today, or yesterday-to-today when the employee has an overnight (two-day) schedule.
export function useTodayMarksDetailNavigation(
  hasOvernightSchedule: boolean,
): UseTodayMarksDetailNavigationResult {
  const navigate = useNavigate();

  const handleViewTodayMarksDetail = useCallback(() => {
    const today = new Date();
    const to = formatDateToYYYYMMDD(today);
    let from = to;
    if (hasOvernightSchedule) {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      from = formatDateToYYYYMMDD(yesterday);
    }
    void navigate(`${ROUTE_DEFINITIONS.INICIO.path}?from=${from}&to=${to}`);
  }, [navigate, hasOvernightSchedule]);

  return { handleViewTodayMarksDetail };
}

export default useTodayMarksDetailNavigation;
